/* eslint-disable import/no-dynamic-require */
import loadRequire from './loadRequire';

let promise;

export default function loadFlameChartJs() {
  if (promise) {
    return promise;
  }
  promise = loadRequire().then((require) => {
    return new Promise((resolve) => {
      require(['flame-chart-js'], resolve);
    });
  });
  return promise;
}
